import { render, staticRenderFns } from "./ModalImpressao.vue?vue&type=template&id=c2afec4a&scoped=true&"
import script from "./ModalImpressao.vue?vue&type=script&lang=js&"
export * from "./ModalImpressao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressao.vue?vue&type=style&index=0&id=c2afec4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2afec4a",
  null
  
)

export default component.exports